// extracted by mini-css-extract-plugin
module.exports = {"selectedSalary":"SalarySlider_selectedSalary__16iWr","number":"SalarySlider_number__23Wy8"};